import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const TextFieldGray = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#BCBCBC',
        borderRadius: 0,
        border: '4px solid',
        height: 60,
        justifyContent: 'center',
      },
      '&:hover fieldset': {
        borderColor: '#BCBCBC',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#BCBCBC',
      },
    },
  },
})(TextField);

export default TextFieldGray;
